// models/CreditCardCollectionModel.ts
import * as Yup from "yup";

export interface ICreditCardCollectionModel {
  // Cari Bilgiler
  firstName: string;
  lastName: string;

  // İşlem Tarihi
  transactionDate: string; // ISO string (LocalDate -> string)

  // Tutarlar
  bankAmount: number | null;
  customerAmount: number | null;
  currency: string;

  // Makbuz ve IBAN
  receiptNumber: string;
  iban: string;

  // Döviz Kurları
  bankRate: number | null;
  customerRate: number | null;

  // Şube ve İşlem Yapan
  branch: string;
  operator: string;

  // Açıklama
  description: string;

  // Sanal POS ve Özel Kod
  virtualPosNumber: string;
  specialCode: string;

  // Finans Bilgileri
  financialInfo: string;
  cardNumber: string;
  cvv: string;
  cardType: string;
  cardHolder: string;
  installmentCount: number | null;
  transactionType: string;
  authenticationType: string;
}

// 🟢 Formik initialValues
export const initialCreditCardCollectionValues: ICreditCardCollectionModel = {
  firstName: "",
  lastName: "",
  transactionDate: "",

  bankAmount: null,
  customerAmount: null,
  currency: "",

  receiptNumber: "",
  iban: "",

  bankRate: null,
  customerRate: null,

  branch: "",
  operator: "",

  description: "",

  virtualPosNumber: "",
  specialCode: "",

  financialInfo: "",
  cardNumber: "",
  cvv: "",
  cardType: "",
  cardHolder: "",
  installmentCount: null,
  transactionType: "",
  authenticationType: "",
};

// validationschema
export const creditCardCollectionSchema = Yup.object().shape({
  // Cari Bilgiler
  firstName: Yup.string()
    .required("Ad zorunludur")
    .max(100, "Ad en fazla 100 karakter olmalıdır"),

  lastName: Yup.string()
    .required("Soyad zorunludur")
    .max(100, "Soyad en fazla 100 karakter olmalıdır"),

  // İşlem Tarihi
  transactionDate: Yup.date()
    .required("Tarih zorunludur"),

 // Tutarlar
bankAmount: Yup.number()
  .typeError("Banka tutarı sayısal olmalıdır")
  .required("Banka tutarı zorunludur")
  .min(0, "Banka tutarı 0'dan büyük olmalıdır"),

customerAmount: Yup.number()
  .typeError("Cari tutar sayısal olmalıdır")
  .required("Cari tutar zorunludur")
  .min(0, "Cari tutar 0'dan büyük olmalıdır"),




  currency: Yup.string()
    .required("Para birimi zorunludur")
    .max(10, "Para birimi en fazla 10 karakter olmalıdır"),

  // Makbuz ve IBAN
  receiptNumber: Yup.string()
    .max(50, "Makbuz numarası en fazla 50 karakter olmalıdır"),

  iban: Yup.string()
    .max(50, "IBAN en fazla 50 karakter olmalıdır"),

// Döviz Kurları
bankRate: Yup.number()
  .typeError("Banka kuru sayısal olmalıdır")
  .required("Banka kuru zorunludur"),

customerRate: Yup.number()
  .typeError("Cari kuru sayısal olmalıdır")
  .required("Cari kuru zorunludur"),

  // Şube ve İşlem Yapan
  branch: Yup.string()
    .required("İşlem şubesi zorunludur")
    .max(100, "İşlem şubesi en fazla 100 karakter olmalıdır"),

  operator: Yup.string()
    .required("İşlem yapan zorunludur")
    .max(100, "İşlem yapan en fazla 100 karakter olmalıdır"),

  // Açıklama
  description: Yup.string()
    .max(500, "Açıklama en fazla 500 karakter olmalıdır")
    .nullable(),

  // Sanal POS ve Özel Kod
  virtualPosNumber: Yup.string()
    .max(50, "Sanal POS numarası en fazla 50 karakter olmalıdır")
    .nullable(),

  specialCode: Yup.string()
    .max(50, "Özel kod en fazla 50 karakter olmalıdır")
    .nullable(),

  // Finans Bilgileri
  financialInfo: Yup.string()
    .required("Finans bilgisi zorunludur")
    .max(10, "Finans bilgisi en fazla 10 karakter olmalıdır"),

  cardNumber: Yup.string()
    .max(20, "Kart numarası en fazla 20 karakter olmalıdır"),

  cvv: Yup.string()
    .max(5, "CVV en fazla 5 karakter olmalıdır"),

  cardType: Yup.string()
    .required("Kart türü zorunludur")
    .max(10, "Kart türü en fazla 10 karakter olmalıdır"),

  cardHolder: Yup.string()
    .max(100, "Kart sahibi en fazla 100 karakter olmalıdır"),

  installmentCount: Yup.number()
    .min(1, "Taksit sayısı en az 1 olmalıdır")
    .nullable(),

  transactionType: Yup.string()
    .required("Çekim türü zorunludur")
    .max(20, "Çekim türü en fazla 20 karakter olmalıdır"),

  authenticationType: Yup.string()
    .required("Doğrulama türü zorunludur")
    .max(10, "Doğrulama türü en fazla 10 karakter olmalıdır"),
});


export const CARD_TYPE = [
 { value: 'VISA', label: 'VISA' },
 { value: 'MASTERCARD', label: 'MasterCard' },
] as const

export const TRANSACTION_TYPE = [
{ value: 'SALE', label: 'Satış' },
{ value: 'REFUND', label: 'İade' },
] as const

export const AUTHENTICATION_TYPE = [
{ value: '3DSECURE', label: '3D Secure' },
{ value: 'NON3D', label: '3D Secure Değil' },
] as const

export const FINANCIAL_INFOTYPE = [
{ value: 'TL', label: 'TL' },
{ value: 'EUR', label: 'EUR' },
{ value: 'USD' , label: 'USD'}
] as const


export const CURRENCY_TYPE = [
{ value: 'TL', label: 'TL' },
{ value: 'EUR', label: 'EUR' },
{ value: 'USD' , label: 'USD'}
] as const